export default __webpack_public_path__ + "static/efficient-shopper-6f1d00beb790873618e630bbd8ab6326.jpg";